import React, { Component } from 'react';
import { ANCHOR_SERVICES_URL } from '../../../constants/apiUrls/apiUrls';
import { ANCHOR_SERVICES } from '../../../constants/anchorServices';
import callApi from '../../../utils/callApi';
import Instagram from '../../../components/anchorComponents/SocialMediaComponents/Instagram';
import Youtube from '../../../components/anchorComponents/SocialMediaComponents/Youtube';
import Twitter from '../../../components/anchorComponents/SocialMediaComponents/Twitter';
import SMIV2 from '../AnchorBroadcast/BroadcastPlayer/streamingApi/v2/smiV2Instance';
import AnchorDashboardHeader from '../../../components/AnchorDashboardHeader/AnchorDashboardHeader';

class AnchorSocialMediaSettings extends Component {
  constructor(props) {
    super(props);
    this.state = {
      socialMediaService: null
    }
  }

  fetchAnchorServicesUrls = anchorName => {
    const url = encodeURI(ANCHOR_SERVICES_URL.replace('{anchorName}', anchorName));
    callApi(url, 'GET', undefined, undefined, undefined, true, true, true)
    .then(res => {
      const services = res.data.services;
      const socialMediaService = services.find(service => service.name === ANCHOR_SERVICES.SOCIAL_MEDIA);
      this.smiv2api = new SMIV2({
        apiUrl: socialMediaService.url,
        // apiUrl: 'http://127.0.0.1:8080',
        whitelisted: anchorName.toLowerCase() === 'whitneystjohn'
      });
      
      this.setState({ socialMediaService });
      
    })
    .catch(err => {
      console.error(err);
    })
  };

  componentDidMount() {
    const { username } = this.props.user.user;
    
    this.fetchAnchorServicesUrls(username);
  }

  render() {
    const { user } = this.props;
    const { socialMediaService } = this.state;
    return (
      <div className="social-media-settings">
        <AnchorDashboardHeader heading={'Social Media'} />
        <div className="container center-col">
          {socialMediaService &&
            <React.Fragment>
              <Instagram user={user} token={socialMediaService.token} api={this.smiv2api}/>
              <Youtube user={user} token={socialMediaService.token} api={this.smiv2api}/>
              <Twitter user={user} token={socialMediaService.token} api={this.smiv2api}/>
            </React.Fragment>
          }
        </div>
      </div>
    );
  }
}

export default AnchorSocialMediaSettings;
